import React from "react";
import { StyleSheet, View } from "react-native";

import { kStyleConst } from "src/kStyle";

import AddAttachmentButton from "./AddAttachmentButton";
import AddLinkButton from "./AddLinkButton";
import AddTemplateButton from "./AddTemplateButton";
import SendButton from "./SendButton";
import { isWeb } from "./utils";

const Toolbar: React.FC = ({ children }) => {
  return (
    <View style={[styles.flexRow, styles.alignCenter, styles.justifyBetween, styles.m1]}>
      <View style={[styles.flexRow, styles.alignCenter]}>{children}</View>
      <SendButton />
    </View>
  );
};

const ComposerToolbar: React.FC = () => {
  if (isWeb) {
    return (
      <Toolbar>
        <AddAttachmentButton />
        <AddLinkButton />
        <AddTemplateButton />
      </Toolbar>
    );
  }

  return (
    <Toolbar>
      <AddAttachmentButton />
    </Toolbar>
  );
};

export default ComposerToolbar;

const styles = StyleSheet.create({
  alignCenter: {
    alignItems: "center",
  },
  flexRow: {
    flexDirection: "row",
  },
  justifyBetween: {
    justifyContent: "space-between",
  },
  m1: {
    margin: kStyleConst.kSpacing,
  },
});
